import React from 'react'

const Loading = () => {
  return (
    <div className=''>
        {/* <h2>Welcome to animations</h2> */}
        <div className="animate">
            <h3 className="dots"></h3>
            <h3 className="dots"></h3>
            <h3 className="dots"></h3>
            <h3 className="dots"></h3>
        </div>
    </div>
  )
}

export default Loading;